import { Provider } from "react-redux"; // Import Provider from react-redux
import { Route, Routes } from "react-router-dom";
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PersistGate } from "redux-persist/integration/react";
import "./App.css";
import { UserRolePermissionProvider } from "./Context/UserRolePermission/UserRolePermissionState";
import Login from "./Pages/Auth/Login/Login";
import OTPVerification from "./Pages/Auth/OTPVerification";
// import Dashboard from "./Pages/Dashboard";
// import ManufacturesList from "./Pages/Manufactures/ManufactureList";
// import ManufacturesDetails from "./Pages/Manufactures/ManufacturesDetails";
// import Menus from "./Pages/Menu";
// import AddMenu from "./Pages/Menu/AddMenu";
// import MenuDetails from "./Pages/Menu/MenuDetails";
// import UpdateMenu from "./Pages/Menu/UpdateMenu";
// import OrderDetails from "./Pages/Orders/OrderDetails";
// import OrderList from "./Pages/Orders/OrderList";
// import Page from "./Pages/Page";
// import AddPage from "./Pages/Page/AddPage";
// import PageDetails from "./Pages/Page/PageDetails";
// import UpdatePage from "./Pages/Page/UpdatePage";
import ProductCategory from "./Pages/ProductCategory";
import AddProductCategory from "./Pages/ProductCategory/Addcategory";
import CategoryDetails from "./Pages/ProductCategory/Categorydetails";
import UpdateProductCategory from "./Pages/ProductCategory/UpdateCategory";
import ProductMetal from "./Pages/ProductMetal";
import AddProductMetal from "./Pages/ProductMetal/AddMetal";
import MetalDetails from "./Pages/ProductMetal/MetalDetails";
import UpdateProductMetal from "./Pages/ProductMetal/UpdateProductMetal";
import ProductPurityModule from "./Pages/ProductPurity";
import AddProductPurity from "./Pages/ProductPurity/AddProductPurity";
import ProductPurityDetails from "./Pages/ProductPurity/ProductPurityDetails";
import UpdateProductPurity from "./Pages/ProductPurity/UpdateProductPurity";
import AddProducts from "./Pages/Products/AddProducts";
import ProductDetails from "./Pages/Products/ProductDetails";
import ProductList from "./Pages/Products/ProductList";
import UpdateProducts from "./Pages/Products/UpdateProducts";
import RolePermissionList from "./Pages/RolePermission/RolePermissionList";
import RolePermissionModuleList from "./Pages/RolePermission/RolePermissionModuleList";
import UserRolePermissionList from "./Pages/UserRolePermission/UserRolePermissionList";
import UserRolePermissionModuleList from "./Pages/UserRolePermission/UserRolePermissionModuleList";
import AddUser from "./Pages/Users/AddUser";
import UpdateUser from "./Pages/Users/UpdateUser";
import UserDetails from "./Pages/Users/UserDetails";
import UsersList from "./Pages/Users/UserList";
import { persistor, store } from "./Store"; // Import your Redux store
import PublicRoute from "./Routes/PublicRoute";
import PrivateRoute from "./Routes/PrivateRoute";
import AddManufactures from "./Pages/Manufactures/AddManufactures";
import UpdateManufactures from "./Pages/Manufactures/UpdateManufactures";
import RevenuePage from "./Pages/Revenue";
import TransportList from "./Pages/Transport";
import Dashboard from "./Pages/Dashboard";
import ManufacturesList from "./Pages/Manufactures/ManufactureList";
import ManufacturesDetails from "./Pages/Manufactures/ManufacturesDetails";
import OrderList from "./Pages/Orders/OrderList";
import OrderDetails from "./Pages/Orders/OrderDetails";
import Menus from "./Pages/Menu";
import AddMenu from "./Pages/Menu/AddMenu";
import MenuDetails from "./Pages/Menu/MenuDetails";
import UpdateMenu from "./Pages/Menu/UpdateMenu";
import Page from "./Pages/Page";
import AddPage from "./Pages/Page/AddPage";
import PageDetails from "./Pages/Page/PageDetails";
import UpdatePage from "./Pages/Page/UpdatePage";
import WebLogin from "./Pages/Website/Auth/Login";
import ErrorPage from "./Pages/Website/ErrorPage";
import Onboarding from "./Pages/Website/Auth/Onboarding";
import Layout from "./Pages/Website/Layout";
import Banner from "./Pages/Website/LandingPage/Banner";
import BrandImages from "./Pages/Website/LandingPage/BrandImages";
import ShopByCategory from "./Pages/Website/LandingPage/CategorySection";
import LandingPage from "./Pages/Website/LandingPage";
import TopSellingProducts from "./Pages/Website/LandingPage/TopSellingProducts";
import SubscriptionPlan from "./Pages/Website/Auth/SubscriptionPlan";
import SubCategories from "./Pages/Website/SubCategories";
import ProductDetail from "./Pages/Website/Products/productDetailPage";
import CustomerReview from "./Pages/Website/CustomerReview";
import Wishlist from "./Pages/Website/Wishlist";
import Header from "./Pages/Website/Layout/Header/Header";
import LatestBrandCollection from "./Pages/Website/LandingPage/LatestBrandCollection";
import ShopByColor from "./Pages/Website/LandingPage/ShopByColor";
import EmptyWishlistPage from "./Pages/Website/Wishlist/EmptyWishlistPage";
import Footer from "./Pages/Website/Layout/Footer/Footer";
import Cart from "./Pages/Website/Cart";
import EmptyCart from "./Pages/Website/Cart/EmptyCart";
import ShopByCategorySlider from "./Pages/Website/ShopByCategorySlider";
import OrderSummary from "./Pages/Website/Order/OrderSummary";
import StaticServicesInfo from "./Pages/Website/LandingPage/StaticServicesInfo";
import ProductListingPage from "./Pages/Website/Products/ProductListingPage";
import ProductListsPage from "./Pages/Website/Products/ProductListingPage";
import MyAccount from "./Pages/Website/Auth/MyAccount";
import ManageProfile from "./Pages/Website/Auth/MyAccount/ManageProfile";
import MyOrders from "./Pages/Website/Auth/MyAccount/MyOrders";
import MySubscription from "./Pages/Website/Auth/SubscriptionPlan/MySubscription";
import Wallet from "./Pages/Website/Auth/MyAccount/Wallet";
import RewardPoints from "./Pages/Website/Auth/MyAccount/RewardPoints";
import ProductsRewardPoint from "./Pages/Website/Auth/MyAccount/RewardPoints/ProductsRewardPoint";
import MyAddress from "./Pages/Website/Auth/MyAccount/MyAddress";
import CustomAddEditAddress from "./Pages/Website/CustomComponents/CustomAddEditAddress";
import AddAddress from "./Pages/Website/Auth/MyAccount/MyAddress/AddAddress";
import EditAddress from "./Pages/Website/Auth/MyAccount/MyAddress/EditAddress";
import Allcategories from "./Pages/Website/AllCategories";
import AllShopByColors from "./Pages/Website/AllShopByColors";
import TermsAndCondition from "./Pages/Website/Auth/Pages/TermsAndCondition";
import PrivacyPolicy from "./Pages/Website/Auth/Pages/PrivacyPolicy";
import WelcomeScreen from "./Pages/Website/WelcomeScreen/PartnersScreen";
import AboutUs from "./Pages/Website/WelcomeScreen/AboutUs";
import ContactUs from "./Pages/Website/WelcomeScreen/ContactUs";
import Share from "./Pages/Website/Auth/MyAccount/share";
import OrderWeightInfoPopup from "./Pages/Website/Auth/MyAccount/CustomModals/OrderWeightInfoPopup";
import SelectAddressComponent from "./Pages/Website/Order/SelectAddress";
import ManufacturerPage from "./Pages/Website/WelcomeScreen/Manufacturer";
import ProfileUnderReview from "./Pages/Website/Auth/ProfileReview/ProfileUnderReview";
import ProfileNotApproved from "./Pages/Website/Auth/ProfileReview/ProfileNotApproved";
import ProfileVerified from "./Pages/Website/Auth/ProfileReview/ProfileVerified";
import ProfilePending from "./Pages/Website/Auth/ProfileReview/ProfilePending";
import TransportDetails from "./Pages/Transport/TransportDetails";
import AddTransport from "./Pages/Transport/AddTransport";
import EditTransport from "./Pages/Transport/EditTransport";
import FilterOptions from "./Pages/Website/FilterComponent/FilterList/FilterOptions";
import OurBrands from "./Pages/Website/OurBrands";
import CancelOrder from "./Pages/Website/Auth/MyAccount/MyOrders/CancelOrder";
import WriteAReview from "./Pages/Website/Auth/MyAccount/MyOrders/WriteAReview";
import LiveRateComponent from "./Pages/Website/Auth/LiveRateComponent";
import PartnersComunity from "./Pages/Website/PartnersComunity";
import ScrollToTop from "./Pages/ScrollToTop";
import SubCategoriesOrders from "./Pages/Website/Auth/MyAccount/RewardPoints/SubCategoriesOrders/SubCategoriesOrders";
import InitialRewardPointScreen from "./Pages/Website/Auth/MyAccount/RewardPoints/InitialRewardPointScreen/InitialRewardPointScreen";
import SubcategoriesRewardsScreen from "./Pages/Website/Auth/MyAccount/RewardPoints/SubcategoriesRewardsScreen/SubcategoriesRewardsScreen";
import RewardPointTickets from "./Pages/Website/Auth/MyAccount/RewardPoints/RewardPointTickets/RewardPointTickets";
import PreOrders from "./Pages/Website/Auth/MyAccount/PreOrders";
import PaymentCard from "./Pages/Website/Cart/PaymentCard";
import CartBrands from "./Pages/Website/CartBrands";
import DigitalCard from "./Components/DigitalCard/DigitalCard";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <UserRolePermissionProvider>
          <div className="App">
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
              transition={Bounce}
              toastStyle={{
                // zIndex: 9999,
                backgroundColor: "#3F3939",
              }}
              style={{ zIndex: 30000 }}
            />
            <ScrollToTop />

            {/* <ToastContainer /> */}
            <Routes>
              {/* Public Routes code -- admin */}
              {/* <Route element={<PublicRoute />}> */}
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin/otpVerification"
                element={<OTPVerification />}
              />
              {/* </Route> */}
              {/* Private Routes code -- admin */}
              <Route element={<PrivateRoute />}>
                <Route path="/admin/dashboard" element={<Dashboard />} />
                <Route path="/admin/userList" element={<UsersList />} />
                <Route path="/admin/addUser" element={<AddUser />} />
                <Route path="/admin/userList/edit" element={<UpdateUser />} />
                <Route
                  path="/admin/userDetails/:userId"
                  element={<UserDetails />}
                />
                <Route path="/admin/productList" element={<ProductList />} />
                <Route
                  path="/admin/productList/edit"
                  element={<UpdateProducts />}
                />
                <Route path="/admin/addProducts" element={<AddProducts />} />
                <Route
                  path="/admin/productDetails/:productName"
                  element={<ProductDetails />}
                />
                <Route
                  path="/admin/productCategory"
                  element={<ProductCategory />}
                />
                <Route
                  path="/admin/AddProductCategory"
                  element={<AddProductCategory />}
                />
                <Route
                  path="/admin/productCategory/:categoryId"
                  element={<CategoryDetails />}
                />
                <Route
                  path="/admin/productCategory/edit"
                  element={<UpdateProductCategory />}
                />
                <Route path="/admin/productMetal" element={<ProductMetal />} />
                <Route
                  path="/admin/AddProductMetal"
                  element={<AddProductMetal />}
                />
                <Route
                  path="/admin/productMetal/:metalId"
                  element={<MetalDetails />}
                />
                <Route
                  path="/admin/productMetal/edit"
                  element={<UpdateProductMetal />}
                />
                <Route
                  path="/admin/productPurity"
                  element={<ProductPurityModule />}
                />
                <Route
                  path="/admin/productPurity/edit"
                  element={<UpdateProductPurity />}
                />
                <Route
                  path="/admin/productPurity/:productId"
                  element={<ProductPurityDetails />}
                />
                <Route
                  path="/admin/AddProductPurity"
                  element={<AddProductPurity />}
                />
                <Route
                  path="/admin/manufacturesList"
                  element={<ManufacturesList />}
                />

                <Route
                  path="/admin/addManufactures"
                  element={<AddManufactures />}
                />

                <Route
                  path="/admin/manufacturesList/edit"
                  element={<UpdateManufactures />}
                />

                <Route
                  path="/admin/manufactureList/:manufactureId"
                  element={<ManufacturesDetails />}
                />
                <Route path="/admin/RevenuePage" element={<RevenuePage />} />

                <Route
                  path="/admin/userRolePermissionList"
                  element={<UserRolePermissionList />}
                />
                <Route
                  path="/admin/userRolePermissionModuleList"
                  element={<UserRolePermissionModuleList />}
                />
                <Route
                  path="/admin/rolePermissionList"
                  element={<RolePermissionList />}
                />
                <Route
                  path="/admin/rolePermissionModuleList"
                  element={<RolePermissionModuleList />}
                />
                <Route path="/admin/transport" element={<TransportList />} />
                <Route
                  path="/admin/transport/:transportId"
                  element={<TransportDetails />}
                />
                <Route
                  path="/admin/transport/add-transport"
                  element={<AddTransport />}
                />
                <Route
                  path="/admin/transport/edit-transport"
                  element={<EditTransport />}
                />
                <Route path="/admin/orderList" element={<OrderList />} />
                <Route
                  path="/admin/orderList/:orderId"
                  element={<OrderDetails />}
                />
                <Route path="/admin/menu" element={<Menus />} />
                <Route path="/admin/AddMenu" element={<AddMenu />} />
                <Route path="/admin/menu/:menuId" element={<MenuDetails />} />
                <Route path="/admin/menu/edit" element={<UpdateMenu />} />
                <Route path="/admin/page" element={<Page />} />
                <Route path="/admin/AddPage" element={<AddPage />} />
                <Route path="/admin/page/:pageId" element={<PageDetails />} />
                <Route path="/admin/page/edit" element={<UpdatePage />} />
                <Route path="/menu" element={<Menus />} />
                <Route path="/AddMenu" element={<AddMenu />} />
                <Route path="/menu/:menuId" element={<MenuDetails />} />
                <Route path="/menu/edit" element={<UpdateMenu />} />
                <Route path="/page" element={<Page />} />
                <Route path="/AddPage" element={<AddPage />} />
                <Route path="/page/:pageId" element={<PageDetails />} />
                <Route path="/page/edit" element={<UpdatePage />} />
              </Route>

              {/*---------- Website routes ---------- */}

              {/* Private Routes */}
              <Route element={<PrivateRoute />}>
                {/* private route starts here */}
                <Route path="/login" element={<WebLogin />} /> {/*login page */}
                <Route path="/home" element={<LandingPage />} />{" "}
                {/*landing page */}
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/my-account" element={<MyAccount />} />
                <Route
                  path="/my-account/manage-profile"
                  element={<ManageProfile />}
                />
                <Route path="/my-account/my-orders" element={<MyOrders />} />
                <Route path="/my-account/pre-orders" element={<PreOrders />} />
                <Route
                  path="/my-account/my-orders/cancel-order/:orderId"
                  element={<CancelOrder />}
                />
                <Route
                  path="/my-account/my-orders/write-a-review"
                  element={<WriteAReview />}
                />
                <Route
                  path="/my-account/my-orders/return-order/:orderId"
                  element={<CancelOrder />}
                />
                <Route
                  path="/my-account/my-subscription"
                  element={<MySubscription />}
                />
                <Route path="/my-account/my-address" element={<MyAddress />} />
                <Route
                  path="/my-account/add-address"
                  element={<AddAddress />}
                />
                <Route
                  path="/my-account/edit-address"
                  element={<EditAddress />}
                />
                <Route path="/my-account/wallet" element={<Wallet />} />
                <Route path="/my-account/share" element={<Share />} />
                <Route
                  path="/my-account/start-reward-points"
                  element={<InitialRewardPointScreen />}
                />
                <Route
                  path="/my-account/reward-tickets"
                  element={<RewardPointTickets />}
                />
                <Route
                  path="/my-account/reward-points"
                  // element={<RewardPoints />}
                  element={<ProductsRewardPoint />}
                  // element={<InitialRewardPointScreen />}
                />
                <Route
                  path="/my-account/reward-points/:name"
                  // element={<ProductsRewardPoint />}
                  element={<SubCategoriesOrders />}
                />
                <Route
                  path="/my-account/reward-points/sub-categories"
                  element={<SubcategoriesRewardsScreen />}
                />
                <Route
                  path="/my-account/terms-and-conditions"
                  element={<TermsAndCondition showHeaderFooter={true} />}
                />
                <Route
                  path="/my-account/live-rate"
                  element={<LiveRateComponent />}
                />
                <Route path="/our-brands" element={<OurBrands />} />
                <Route path="/banner" element={<Banner />} />
                <Route path="/brandImages" element={<BrandImages />} />
                <Route path="/shopByCategory" element={<ShopByCategory />} />
                <Route
                  path="/shopByCategorySlider"
                  element={<ShopByCategorySlider />}
                />
                <Route
                  path="/topSellingProducts"
                  element={<TopSellingProducts />}
                />
                <Route path="/customer-review" element={<CustomerReview />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/wishlist-empty" element={<EmptyWishlistPage />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/cart-brands" element={<CartBrands />} />
                <Route path="/cart-empty" element={<EmptyCart />} />
                <Route path="/order-summary" element={<OrderSummary />} />
                <Route path="/footer" element={<Footer />} />
                <Route
                  path="/static-service-info"
                  element={<StaticServicesInfo />}
                />
                <Route path="/header" element={<Header />} />
                {/* <Route path="/" element={<LandingPage />} /> */}
                <Route path="/sub-categories" element={<SubCategories />} />
                <Route
                  path="/collections/brand-name"
                  element={<SubCategories />}
                />
                <Route
                  path="/productDetail/:productId"
                  element={<ProductDetail />}
                />
                <Route
                  path="/productsList/:productId"
                  element={<ProductListsPage />}
                />
                <Route
                  path="/shop-by-color/:name"
                  element={<ProductListsPage />}
                />
                <Route
                  path="/all-product-listing"
                  element={<ProductListsPage />}
                />
                <Route
                  path="/top-selling-products"
                  element={<ProductListsPage />}
                />
                <Route
                  path="/new-arrival-products"
                  element={<ProductListsPage />}
                />
                <Route
                  path="/all-categories-listing"
                  element={<Allcategories />}
                />
                <Route path="/shop-by-category" element={<Allcategories />} />
                <Route path="/nosepin-collection" element={<Allcategories />} />
                <Route path="/rings-collection" element={<Allcategories />} />
                <Route
                  path="/categories-by-brand"
                  element={<Allcategories />}
                />
                <Route path="/shop-by-colors" element={<AllShopByColors />} />
                <Route
                  path="/subscriptionPlan"
                  element={<SubscriptionPlan />}
                />
                <Route
                  path="/profile-under-review"
                  element={<ProfileUnderReview />}
                />
                <Route
                  path="/profile-not-approved"
                  element={<ProfileNotApproved />}
                />
                <Route path="/profile-verified" element={<ProfileVerified />} />
                <Route path="/profile-pending" element={<ProfilePending />} />
                {/* <Route path="/welcome-zabali" element={<WelcomeScreen />} /> */}
                <Route path="/" element={<WelcomeScreen />} />
                <Route path="/partners" element={<PartnersComunity />} />
                <Route path="/inquiry-form" element={<ManufacturerPage />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route
                  path="order-weight-info-popup"
                  element={<OrderWeightInfoPopup />}
                />
                <Route
                  path="/select-address-component"
                  element={<SelectAddressComponent />}
                />
                {/* private route ends here */}
              </Route>

              {/* Error Page - 404 */}
              <Route path="/*" element={<ErrorPage />} />

              {/* T&C */}
              <Route
                path="/terms-and-conditions"
                element={<TermsAndCondition showHeaderFooter={false} />}
              />
              {/* Privacy Policy */}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/check-filter" element={<FilterOptions />} />
              <Route path="/payment-card" element={<PaymentCard />} />
              <Route path="/business-card" element={<DigitalCard />} />
            </Routes>
          </div>
        </UserRolePermissionProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
